<app-header></app-header>
<div style="position: relative;">
  <div class="map-top-header">
    <div class="map-search-box">
      <input class="map-search-input" type="text" placeholder="Future enhancement.." />
      <button class="map-search-btn">
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="13.9908" cy="14.2886" r="8.16459" stroke="currentColor" stroke-width="2.72153" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M20.1134 20.4121L26.2368 26.5356" stroke="currentColor" stroke-width="2.72153" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
    <div class="bgtngrops">
      <div class="btn-group-toggle" data-toggle="buttons" *ngFor="let btn of filterlayers(layerlist)">
        <label class="btn headbtn"
          [ngClass]="[ btn.checked ? 'active ' : '', btn.label?.toLowerCase() === 'zones' ? 'disabled btn-grey active' : 'btn-secondary']">
          <input type="checkbox" [checked]="btn.checked" (change)="changeToggleLayer(btn)"
            [disabled]="btn.label?.toLowerCase() === 'zones'" />
          {{ btn.label }}
        </label>
      </div>
    </div>
    <div class="back-btn-wrapper">
      <div class="acpt-btn-wrap">
        <button class="btn-green btn accept-btn-create-game" [disabled]="!startlocation"
          (click)="openGameCreateInvitationModal($event)">
          Accept
        </button>
      </div>
      <button class="btn btn-theme" (click)="goBack()">Cancel</button>
    </div>
    <div class="btn-map-icon">
      <button class="btnmap" (click)="triggerTokenZoom()"><img class=""
          src="assets/icons/icon-map-location.svg" /></button>
      <button class="btnmap" (click)="triggerZoomIn()"><img class="" src="assets/icons/icon-map-plus.svg" /></button>
      <button class="btnmap" (click)="triggerZoomOut()"><img class="" src="assets/icons/icon-map-minus.svg" /></button>
    </div>

  </div>

  <div class="color-btn-box">
    <h4 (click)="toggleCultureList()" *ngIf="currentLayerName">
      {{ currentLayerName }}{{ currentLayerName.toLowerCase() === 'state' || currentLayerName.toLowerCase() ===
      'culture' ? 's' : '' }}
      <i class="fa" [ngClass]="isCultureVisible ? 'fa-angle-down' : 'fa-angle-up'"
        style="margin-left: auto; color: #fff;"></i>
    </h4>

    <ng-container *ngIf="isCultureVisible">

      <!-- If currentLayerName is 'heightmap', show static image -->
      <div *ngIf="currentLayerName === 'heightmap'; else showLegend">
        <div class="d-flex flex-column align-items-center justify-content-center g-10">
          <img src="/assets/images/heightmap-legend.png" alt="Heightmap Legend" style="width: 100%; padding: 10px;">
          <p class="height-text" (click)="navigateToElevationLink()">ELEVATIONS &#40;Feet&#41;</p>
        </div>
      </div>

      <!-- Fallback to normal legend display -->
      <ng-template #showLegend>
        <ul *ngIf="legendData && legendData.length > 0; else noData">
          <li *ngFor="let data of legendData" (click)="onDynamicDataClick(data.full_name || data.name)" class="">
            <span [ngStyle]="{ 'background-color': data.color }"></span>
            <div class="pointer pointer-cursor-link custom-width-color-btn">{{ data.name }}</div>
          </li>
        </ul>
        <ng-template #noData>
          <p style="color: white; padding-left: 10px;">No data available</p>
        </ng-template>
      </ng-template>

    </ng-container>
  </div>



  <div class="mapdetail-box" [class.open]="sideInfoBar" [class.hidden]="!sideInfoBar" #sideContent>
    <h4 class="mapdetail-header" (click)="toggleMapDetails()">
      MAP DETAILS
      <i class="fa" [ngClass]="isMapDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto"></i>
    </h4>

    <ul *ngIf="isMapDetailsVisible">
      <li *ngIf="map_name">
        World:&nbsp; <span class="pointer pointer-cursor-link pl-2" (click)="navigateToWikiWorld(map_name)">{{ map_name
          || "Unnamed Map" }}</span>
      </li>
      <ng-container *ngIf="objectData; else elseBlockNoData">
        <ng-container *ngFor="let property of objectData | keyvalue : cellDetailsSort">
          <ng-container *ngIf="property.key !== 'id' && property.key !== 'burgs_data'">
            <li [class.bdr-top]="
                property.key === 'State' || property.key === 'Natural Resources'
              ">
              {{ property.key }}:&nbsp;

              <!-- Render resources as links if applicable -->
              <ng-container *ngIf="isResourceField(property.key); else normalLink">
                <ng-container *ngIf="splitResources(property.value)?.length >0; else None">
                  <ng-container *ngFor="
                      let item of splitResources(property.value);
                      let i = index
                    ">
                    <div href="#" class="pointer pointer-cursor-link pl-2" (click)="onResourceClick(item.trim())">
                      {{ item.trim() }}
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #None>
                  <span> None</span>
                </ng-template>
              </ng-container>

              <!-- Fallback: normal value -->
              <ng-template #normalLink>
                <ng-container *ngIf="isLinkField(property.key); else normalValue">
                  <ng-container *ngIf="property?.value;else noValue">
                    <div class="pointer pointer-cursor-link pl-2" (click)="
                      navigateToDynamicLink(property.key, property.value)
                    ">
                      {{ property.value }}
                    </div>
                  </ng-container>
                  <ng-template #noValue>
                    <span>None</span>
                  </ng-template>
                </ng-container>
              </ng-template>
              <ng-template #normalValue>
                <span> {{ property.value }}</span>
              </ng-template>
            </li>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #elseBlockNoData>
        <li>No cell selected</li>
      </ng-template>
    </ul>
  </div>
  <div class="city-detail-box" [class.open]="isCityDetailsVisible" #sideContent>
    <h4 (click)="toggleCityMapDetails()" class="mapdetail-header">
      CITY details
      <i class="fa" [ngClass]="isCityDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto"></i>
    </h4>

    <ul *ngIf="isCityDetailsVisible">
      <ng-container *ngIf="cityData; else elseBlock">
        <ng-container *ngFor="let property of cityData | keyvalue : cityDetailsSort">
          <ng-container *ngIf="property.key == 'City Name'; else normalKeyValue">
            <li (click)="navigateToCityNameWiki()">
              {{ property.key }}:
              <span class="pointer pointer-cursor-link pl-2">{{ property.value }}
              </span>
            </li>
          </ng-container>
          <ng-template #normalKeyValue>
            <li>{{ property.key }}: {{ property.value }}</li>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #elseBlock>
        <li>No city selected</li>
      </ng-template>
    </ul>
  </div>
  <div class="map-view position-relative">
    <div id="map" #map [ngStyle]="{'height': windowmapheight}"></div>

  </div>
</div>
<div class="map-footer">
  <app-footer></app-footer>
</div>